exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-flows-account-___style__header___1yRNb{margin-left:1rem;padding:.67em 0 0;border:none}", ""]);

// exports
exports.locals = {
	"header": "web-flows-account-___style__header___1yRNb"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/flows/account/style.css
// module id = 1336
// module chunks = 0